export default "__VITE_ASSET__BsU43l8F__"